Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBox = void 0;
var _getREM = require("../../getREM");
var _useSpacing2 = require("./useSpacing");
var _Grid = require("../Grid");
var _useColors2 = require("./useColors");
var _useBoxShadows2 = require("./useBoxShadows");
var useBox = exports.useBox = function useBox() {
  var _useColors = (0, _useColors2.useColors)(),
    colors = _useColors.colors;
  var _useSpacing = (0, _useSpacing2.useSpacing)(),
    spacing = _useSpacing.spacing;
  var _useBoxShadows = (0, _useBoxShadows2.useBoxShadows)(),
    boxShadows = _useBoxShadows.boxShadows;
  var box = Object.assign({
    padding: spacing.normal,
    maxWidth: _Grid.grid.maxBoxWidth,
    width: '100%',
    backgroundColor: colors.boxBackground,
    borderRadius: (0, _getREM.getREM)(0.625),
    flexShrink: 1
  }, boxShadows.box.all);
  return {
    box: box
  };
};